// extracted by mini-css-extract-plugin
export var footer = "_hh-0";
export var inherit = "_hh-1";
export var input = "_hh-2";
export var modalContent = "_hh-3";
export var quillEditor = "_hh-4";
export var subtitle = "_hh-5";